import { render } from "./sidebar.vue?vue&type=template&id=c354961a&scoped=true"
import script from "./sidebar.vue?vue&type=script&setup=true&lang=js"
export * from "./sidebar.vue?vue&type=script&setup=true&lang=js"

import "./sidebar.vue?vue&type=style&index=0&id=c354961a&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/.pnpm/vue-loader@17.4.2_vue@3.5.17_webpack@5.97.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c354961a"],['__file',"packages/client/src/core-components/sidebar/sidebar.vue"]])

export default __exports__